// zh-TW is the authoring locale (CLAUDE.md): every player-facing string lives
// here as the master. Other locales (./en-US, ./zh-CN, ./ja-JP) provide partial
// overrides and fall back to this dict, so a raw key can never reach the screen.

export const zhTW = {
  // ── App / boot / menu ──────────────────────────────────────────────
  'app.title': '大逃殺 α',
  'rotate.title': '請直握手機',
  'rotate.sub': '本遊戲為直式設計，請將裝置轉回直向以繼續。',
  'app.subtitle': 'JKBRα — 孤島生存・每日挑戰',
  'auth.guest': '訪客遊玩',
  'auth.login': '登入',
  'auth.register': '註冊',
  'auth.back': '返回',
  'auth.handle.label': '帳號代號',
  'auth.handle.ph': '3–20 字（英數、_、-）',
  'auth.name.label': '顯示名稱（可留空）',
  'auth.name.ph': '想讓別人看到的名字',
  'auth.register.title': '建立帳號',
  'auth.register.submit': '建立並進入',
  'auth.login.title': '登入帳號',
  'auth.login.submit': '登入並進入',
  'auth.invalidHandle': '代號需 3–20 字，僅限英數、底線、連字號。',
  'auth.password.label': '密碼',
  'auth.password.ph': '至少 8 字，含字母與數字',
  'auth.pending': '處理中…',
  'auth.err.bad_password': '密碼太弱：需至少 8 字、且含兩種以上字元類型。',
  'auth.err.handle_taken': '此代號已被使用，請換一個。',
  'auth.err.bad_credentials': '代號或密碼錯誤。',
  'auth.err.offline': '無法連線伺服器，請稍後再試。',
  'app.loading': '載入資源中…',
  'app.loadError': '部分資源載入失敗，請重新整理頁面再試一次。',
  'boot.tap': '輕觸開始',
  'boot.kbd': '鍵盤：方向鍵/WASD 移動・R/H 休息・E 逃脫・空白鍵推進・數字鍵選擇・Esc 返回',
  'boot.hint': '孤島求生 · 最後倖存者獲勝',
  'menu.story': '故事模式',
  'menu.freeplay': '自由對戰',
  'menu.ranked': '排名',
  'menu.rankedOn': '🏅 排名模式：開（公平・無加成）',
  'menu.rankedOff': '🏅 排名模式：關（休閒）',
  'menu.settings': '設定',
  'menu.season': '賽季 Lv.{lv}（{into}/{next}）',
  'menu.loading': '載入帳號中…',
  'menu.seasonCountdown': '賽季剩餘 {days} 天',
  'menu.seasonEnded': '本賽季已結束',
  'menu.seasonUpcoming': '新賽季即將開始',
  'season.s1_tidefall': '「潮落」第一賽季',
  'season.unnamed': '本賽季',
  'menu.back': '返回',
  'menu.chapterSelect': '選擇章節',
  'menu.chapterLocked': '🔒 完成前一章節後解鎖',
  'menu.chaptersCleared': '已通關 {done}/{total} 章',
  'menu.gacha': '轉蛋',
  'menu.collection': '收藏',
  'menu.shop': '商城',
  'menu.progress': '通行證',
  'menu.hubToday': '今日戰場',
  'menu.hubPitch': '單人入場，對抗自主 bot 與其他玩家留下的 ghost；每局結算推進角色、賽季與排行榜。',
  'menu.hubFooter': '目標：成為最後倖存者，或擊敗持鑰者後逃脫。',
  'menu.story.badge': '教學 / 劇情',
  'menu.story.desc': '用章節學會規則、縮圈、逃脫與角色故事。',
  'menu.story.meta': '首局推薦',
  'menu.survival': '生存挑戰',
  'menu.survival.badge': '單人 Roguelite',
  'menu.survival.desc': '一局入島、搜刮、戰鬥、拿魂解鎖角色。',
  'menu.survival.meta': 'Casual',
  'menu.daily': '每日排位',
  'menu.daily.badge': 'Async PvP',
  'menu.daily.desc': '同日同 seed，遇到玩家 ghost，公平規則上榜。',
  'menu.daily.meta': 'Ranked',
  'menu.collection.sub': '出戰角色 / 解鎖',
  'menu.collection.ready': '可解鎖 {n} 名角色',
  'menu.collection.next': '還差 {n} 魂解鎖',
  'menu.collection.complete': 'Roster 已全解鎖',
  'menu.progress.sub': '任務 / BP 獎勵',
  'menu.shop.sub': '寶石 / 造型資源',
  'shop.title': '寶石商城',
  'shop.balance': '持有 💎 {gem}',
  'shop.bonus': '含紅利 +{bonus}',
  'shop.confirm': '購買 💎 {gem}？將前往 Stripe 安全付款頁完成付款。',
  'shop.redirecting': '前往安全付款頁…',
  'shop.buy': '購買',
  'shop.success': '購買完成，💎 已入帳。餘額：{gem}',
  'shop.offline': '商城需要連線帳號才能購買。請稍後再試。',
  'collection.title': '收藏',
  'collection.empty': '尚無收藏。去轉蛋抽抽看，把喜歡的角色與造型收進來吧！',
  'collection.offline': '收藏需要連線帳號才能讀取。請稍後再試。',
  'collection.equipped': '裝備中',
  'collection.tapEquip': '點角色卡即可換上外觀（不影響數值）',
  'collection.tapEquipShort': '點擊裝備外觀',
  // 出戰角色（roguelite loadout）— 影響起手武器與被動，非外觀
  'collection.activeTitle': '出戰角色',
  'collection.tapDeploy': '點角色卡選擇出戰（影響起手武器與被動）',
  'collection.deploying': '出戰中',
  'collection.unlock.free': '初始',
  'collection.unlock.gacha': '轉蛋',
  'char.c_default.name': '預設戰士',
  'char.c_kurotobi_nagi.name': '黑鳶 凪',
  'char.c_shiran_uta.name': '白蘭 詩',
  'passive.none': '無被動',
  'passive.first_blood': '首殺：怒氣 +50',
  // 局內強化（roguelite run boons）
  'fail.noBoon': '沒有可選的強化。',
  'log.boonOffer': '擊殺對手！可選擇一項強化。',
  'log.boonTaken': '強化生效：{name}。',
  'boon.title': '選擇強化',
  'boon.generic': '強化',
  'boon.b_str.name': '猛攻',
  'boon.b_str.desc': '攻擊 +6',
  'boon.b_guard.name': '堅守',
  'boon.b_guard.desc': '防禦 +5',
  'boon.b_focus.name': '專注',
  'boon.b_focus.desc': '技巧 +5',
  'boon.b_plate.name': '護甲',
  'boon.b_plate.desc': '裝甲 +4',
  'boon.b_vigor.name': '活力',
  'boon.b_vigor.desc': '最大體力 +30（立即回復）',
  'boon.b_endure.name': '耐力',
  'boon.b_endure.desc': '最大精力 +25（立即回復）',
  // 跨局永久進度（souls 魂 + 解鎖樹）
  'collection.souls': '魂：{n}',
  'collection.unlockCost': '🔒 {n} 魂',
  'collection.cantAfford': '魂不足，無法解鎖。多打幾場累積魂。',
  'collection.gachaOnly': '轉蛋取得',
  'collection.gachaOnlyNote': '此角色需透過轉蛋取得（需連線帳號）。',
  'result.souls': '+{n} 魂（共 {balance}）',
  // 賽季排行榜
  'leaderboard.title': '排行榜',
  'leaderboard.pitch': '每日同 seed 排位：與玩家 ghost 競速，公平規則上榜。',
  'leaderboard.open': '🏆 賽季排行榜',
  'leaderboard.season': '賽季：{id}',
  'leaderboard.empty': '本賽季尚無排名，快去打一場登榜！',
  'leaderboard.offline': '排行榜需要連線帳號才能讀取。請稍後再試。',
  'leaderboard.points': '{n} 分',
  'leaderboard.you': '你',
  'leaderboard.casual': '休閒',
  'leaderboard.ranked': '排名',
  'tier.bronze': '青銅',
  'tier.silver': '白銀',
  'tier.gold': '黃金',
  'tier.platinum': '白金',
  'tier.diamond': '鑽石',
  'tier.master': '大師',
  'leaderboard.me': '你的排名：第 {rank} 名（{points} 分）',
  'leaderboard.meNone': '你尚未登榜——完成一場對戰即可上榜。',

  // ── Settings ──────────────────────────────────────────────
  'settings.title': '設定',
  'settings.pitch': '調整顯示語言與遊戲音效。設定會儲存在此裝置。',
  'settings.language': '語言 / Language',
  'settings.kbd': '［1–4］選擇語言　［Esc］返回',
  'settings.current': '已是目前語言。',
  'settings.audio': '音效',
  'settings.soundOn': '開啟',
  'settings.soundOff': '關閉',

  // ── HUD ──────────────────────────────────────────────
  'hud.alive': '存活 {alive}/{total}',
  'hud.shrink': '距下次禁區擴張：{steps} 步',
  'hud.weather': '天候：{weather}',
  'hud.fogHint': '🌫 視野受限',
  'hud.hp': '生命',
  'hud.sp': '體力',
  'hud.kills': '擊殺 {n}',
  'hud.key': '🔑 已奪得遊戲解除鑰匙',
  'status.weapon': '武器：{w}',
  'combat.miss': '未命中',
  'combat.rage': '怒氣',
  'combat.you': '你',
  'combat.kbd': '［空白］攻擊　［S］必殺　［Esc］逃跑',
  'hud.danger': '⚠ 此區即將成為禁區，盡快離開！',
  'explore.kbd': '方向鍵/WASD 移動・R/H 休息・E 逃脫・Esc 退出',
  'explore.quit': '退出',
  'explore.quitConfirm': '放棄這場對戰、返回主選單？',
  'explore.gotLoot': '＋物資',
  'explore.areaEnemies': '⚠ 此區敵蹤 {n}',
  'explore.objective.title': '本局目標',
  'explore.objective.casual': '成為最後倖存者，或擊敗持鑰者後按「逃脫」離島。',
  'explore.objective.ranked': '每日同 seed 排位：擊敗 ghost 與 bot，結算後以公平規則登榜。',
  'explore.log.open': '記錄',
  'explore.log.title': '行動記錄',
  'explore.log.close': '關閉記錄',
  'explore.intel.open': '情報',
  'explore.intel.close': '關閉情報',
  'explore.intel.enemies': '敵蹤 {n}',
  'explore.intel.key': '鑰匙持有者',
  'explore.intel.ghost': '玩家 ghost',
  'explore.intel.lore': '地點線索',
  'item.bandage': '繃帶',
  'item.energy_drink': '能量飲料',
  'item.painkiller': '止痛藥',
  'item.riceball': '飯糰',
  'item.vest_frag': '防彈背心碎片',
  'item.radar': '雷達',
  'item.generic': '物資',
  'zone.unknown': '未知區域',
  'weapon.fists': '空手',
  'weapon.bat': '金屬球棒',
  'weapon.machete': '柴刀',
  'weapon.saber': '軍刀',
  'weapon.crossbow': '十字弓',
  'weapon.dart': '麻醉飛鏢',
  'weapon.beretta': '貝瑞塔手槍',
  'weapon.uzi': 'Uzi 衝鋒槍',
  'weapon.shotgun': '霰彈槍',
  'weapon.grenade': '手榴彈',

  // ── Actions ──────────────────────────────────────────────
  'action.attack': '攻擊 {name}',
  'action.attackWith': '攻擊（{w}）',
  'action.special': '必殺技！',
  'action.escape': '逃脫',
  'action.flee': '逃跑',
  'rest.sleep': '睡眠（回體力）',
  'rest.heal': '治療（回生命）',

  // ── Failures ──────────────────────────────────────────────
  'fail.forbidden': '⚠ 該地已是禁區，項圈會引爆，無法前往。',
  'fail.sameZone': '你已經在此地，不需移動。',
  'fail.noSp': '體力不足，先休息一下吧。',
  'fail.deadAct': '你已經死亡，無法行動。',
  'fail.noKey': '你還沒有遊戲解除鑰匙，無法逃脫。',
  'fail.notRunning': '比賽尚未開始。',
  'fail.noRage': '怒氣不足，無法使出必殺技。',
  'fail.generic': '這個行動現在無法執行。',

  // ── Log ──────────────────────────────────────────────
  'log.deploy': '你被投放到 {zone}。求生開始。',
  'log.move': '你移動到了 {zone}。',
  'log.search.nothing': '你仔細搜索，但什麼也沒找到。',
  'log.search.item': '你找到了 {item}！',
  'log.search.weapon': '你撿到了武器：{item}！',
  'log.pickup.serverManaged': '你看了看 {item}（連線對戰：物資由伺服器結算）。',
  'log.rest.sp': '你休息片刻，體力恢復了 {n}。',
  'log.rest.hp': '你包紮傷口，生命恢復了 {n}。',
  'log.rest.spFull': '你停下喘口氣，但體力早已是滿的。',
  'log.rest.hpFull': '你檢視傷口，發現已無需包紮。',
  'log.encounter': '你在 {zone} 遇上了 {name}！',
  'log.ambush': '{name} 突然向你襲來！',
  'log.attackHit': '你對 {name} 造成 {dmg} 點傷害！',
  'log.attackMiss': '你的攻擊落空了。',
  'log.counterHit': '{name} 反擊，你受到 {dmg} 點傷害！',
  'log.injury': '{who} 的 {part} 部位受傷了！',
  'log.injurySelf': '你的 {part} 部位受傷了！',
  'log.crit': '會心一擊！',
  'log.youKilled': '你擊倒了 {name}！',
  'log.youDied': '你被 {name} 殺死了。',
  'log.botKill': '{killer} 殺死了 {victim}。',
  'log.collar': '{name} 留在禁區，項圈引爆身亡。',
  'log.broadcast': '【廣播】下列地點即將成為禁區：{zones}。',
  'log.keyDrop': '你從 {name} 身上取得了 🔑 遊戲解除鑰匙！',
  'log.keyLost': '【廣播】{name} 葬身禁區，🔑 遊戲解除鑰匙已轉移至其他學員手中。',
  'log.enemyHit': '{name} 擊中你，造成 {dmg} 點傷害！',
  'log.enemyMiss': '{name} 的攻擊落空了。',
  'log.hazard': '荒野的危險使你損失了 {n} 點生命。',
  'log.youDiedEnv': '你傷重不支，倒了下去……',
  'log.fled': '你脫離了戰鬥。',
  'log.targetGone': '對方已經不在這裡了。',
  'log.actionFailed': '動作失敗，請再試一次。',
  'log.special': '你蓄滿怒氣，使出渾身一擊！',
  'log.serverState': '【伺服器】存活 {alive}/{total}　·　第 {step} 步　·　名次 {rank}',
  'gacha.ssr': 'SSR',
  'gacha.sr': 'SR',
  'gacha.r': 'R',
  'gacha.title': '轉蛋',
  'gacha.titlePreview': '轉蛋（預覽）',
  'gacha.pitch': '抽取角色與造型，擴充出戰選擇；排名模式仍維持公平規則，不出售戰力優勢。',
  'gacha.results.empty': '尚未抽取。十連會顯示角色、造型與素材結果。',
  'gacha.pull10': '十連抽',
  'gacha.pull10Preview': '十連（預覽）',
  'gacha.offline': '伺服器暫時無法連線，目前以預覽模式顯示，稍後再試。',
  'gacha.kbd': '［空白/Enter］抽卡　［Esc］返回',
  'gacha.cost': '每次十連 {n} 鑽',
  'gacha.pity': '距離保底 SSR：還需 {n} 抽',
  'gacha.pityReady': '下一抽必得 SSR！',
  'gacha.balance': '💎 {gem}　🪙 {coin}',
  'gacha.broke': '鑽石不足，無法抽卡。',

  // ── Body parts ──────────────────────────────────────────────
  'part.b': '胸',
  'part.h': '頭',
  'part.a': '腕',
  'part.f': '足',

  // ── Archetype labels ──────────────────────────────────────────────
  'arch.player': '你',
  'arch.hunter': '獵殺型',
  'arch.survivor': '苟活型',
  'arch.looter': '拾荒型',
  'arch.veteran': '老兵型',
  'arch.medic': '結盟型',
  'arch.boss': '監督教官',

  // ── Weather ──────────────────────────────────────────────
  'weather.w0': '晴天',
  'weather.w1': '大晴',
  'weather.w2': '多雲',
  'weather.w3': '小雨',
  'weather.w4': '暴雨',
  'weather.w5': '颱風',
  'weather.w6': '雷雨',
  'weather.w7': '下雪',
  'weather.w8': '起霧',
  'weather.w9': '濃霧',
  'weather.unknown': '天候不明',

  // ── Result ──────────────────────────────────────────────
  'result.win.survivor': '最後倖存',
  'result.win.escape': '成功逃脫孤島',
  'result.lose': '你已出局',
  'result.rank': '名次：{rank} / {total}',
  'result.kills': '擊殺數：{n}',
  'result.survived': '存活步數：{n}',
  'result.rewards': '結算獎勵',
  'result.nextTitle': '下一步',
  'result.nextCollection': '用魂解鎖出戰角色，下一局帶新起手武器與被動入場。',
  'result.nextUnlockReady': '已有足夠魂解鎖 {n} 名角色；進收藏換新起手武器與被動。',
  'result.nextUnlockSoon': '還差 {n} 魂可解鎖下一名角色；再打一局就有明確目標。',
  'result.nextUnlockComplete': '出戰角色已全解鎖；改衝賽季通行證與排行榜。',
  'result.gainCoin': '金幣 +{n}',
  'result.gainXp': '賽季經驗 +{n}',
  'result.levelUp': '賽季等級提升：Lv.{from} → Lv.{to}',
  'result.seasonLv': '賽季等級 Lv.{lv}',
  'result.missionDone': '完成每日任務：{name}',
  'result.settleOffline': '（結算未連線，稍後再同步）',
  'mission.play_1': '出戰一場',
  'mission.kill_3': '擊倒 3 名對手',
  'mission.survive_20': '存活 20 步',
  'mission.generic': '每日挑戰',
  'progress.title': '賽季進度',
  'progress.daily': '每日任務',
  'progress.mission': '{name}　{cur}/{goal}',
  'progress.reward': '・獎 金幣{coin}/經驗{xp}',
  'progress.offline': '進度需連線（?backend=1 並啟動伺服器）。',
  'bp.title': '賽季通行證',
  'bp.claimable': '可領取 {n} 項',
  'bp.claim': '領取獎勵',
  'bp.none': '目前沒有可領取的獎勵',
  'bp.gained': '已領取：金幣 +{coin}、道具 ×{items}',
  'bp.hint': '賽季通行證有 {n} 項可領取（點此前往領取）',
  'bp.track': '通行證軌道　已領 {claimed}/{total} 級',
  'gacha.pulling': '抽取中…',
  'gacha.confirm.q': '確認消耗 {n} 💎進行十連抽？（餘額 {bal} 💎）',
  'gacha.confirm.yes': '確認抽取',
  'gacha.confirm.no': '取消',
  'gacha.confirm.pity': '本次必出 SSR！',
  'gacha.loading': '載入中…',
  'result.settling': '結算中…',
  'bp.claiming': '領取中…',
  'bp.levelLine': 'Lv.{lv}　金幣 {coin}{item}',
  'bp.kind.skin': '＋造型',
  'bp.kind.material': '＋碎片',
  'bp.kind.char': '＋角色',
  'bp.kind.other': '＋道具',
  'result.again': '再玩一局',
  'result.toCollection': '角色解鎖',
  'result.toPass': '通行證',
  'result.toMenu': '回主選單',
  'result.kbd': '［Enter］再玩一場　［Esc］回主選單',
  'result.l-survivor': '你撐到了最後，成為唯一的倖存者。',
  'result.l-escape': '你奪得鑰匙、逃離孤島，掙脫了這場遊戲。',
  'result.l-dead': '遊戲仍在繼續，但你的故事在此畫下句點。',

  // ── Zones（21 個正典地點，忠於小說地圖）──────────────────
  'zone.north_peak.name': '北山頂',
  'zone.north_peak.desc': '島嶼北部的制高點，視野開闊，能俯瞰整片海域與半座島。',
  'zone.north_peak.lore': '站上山頂雖能掌握敵蹤，卻也讓自己無所遁形。',
  'zone.cliff.name': '斷崖',
  'zone.cliff.desc': '臨海的陡峭斷崖，海風呼嘯，腳下是拍打礁石的浪。',
  'zone.cliff.lore': '走投無路的人，有的選擇從這裡縱身一躍。',
  'zone.lighthouse.name': '燈塔',
  'zone.lighthouse.desc': '矗立在東岸的白色燈塔，是島上最顯眼的地標。',
  'zone.lighthouse.lore': '一群人曾在此據守，卻因猜疑與一包毒藥，演成同伴互相殘殺的槍戰。',
  'zone.north_temple.name': '北寺（佛堂）',
  'zone.north_temple.desc': '北部山腰的佛寺，香火早斷，佛像在陰影中靜默。',
  'zone.north_temple.lore': '入夜之後，這裡令人毛骨悚然。',
  'zone.north_knoll.name': '北丘',
  'zone.north_knoll.desc': '長滿芒草的小丘，風一吹便沙沙作響。',
  'zone.north_knoll.lore': '起伏的地形適合伏擊，也適合被伏擊。',
  'zone.central_pond.name': '中央池',
  'zone.central_pond.desc': '島中央的池塘，水面映著天光，四周蘆葦叢生。',
  'zone.central_pond.lore': '與其說是池，不如說是沼澤，令人不安。',
  'zone.west_pond.name': '西池',
  'zone.west_pond.desc': '西側的小池，水色暗綠，岸邊泥濘難行。',
  'zone.west_pond.lore': '想找水源的人會來，但這裡太安靜了。',
  'zone.tourism.name': '觀光協會大樓',
  'zone.tourism.desc': '廢棄的沖木島觀光協會辦公樓，桌上還有褪色的觀光手冊。',
  'zone.tourism.lore': '有人曾在此架起電腦，企圖駭入主辦方的系統、終結這場遊戲。',
  'zone.houses_north.name': '民家聚落（北）',
  'zone.houses_north.desc': '北側的住宅區，門戶洞開，餐桌上的飯菜早已冷掉。',
  'zone.houses_north.lore': '居民早被強制撤離，只剩躲藏者壓抑的呼吸。',
  'zone.clinic.name': '醫療診所',
  'zone.clinic.desc': '島上唯一的診所，藥櫃多半已空，消毒水味殘留。',
  'zone.clinic.lore': '受傷的人都想來，於是這裡也最危險。',
  'zone.school.name': '學校（常時禁區）',
  'zone.school.desc': '你們被投放的學校，如今是主辦方的本部；一靠近，項圈便嗶嗶作響。',
  'zone.school.lore': '此處為「常時禁區」，踏入即引爆項圈——監督教官就在裡面看著你們。',
  'zone.thicket.name': '雜木林',
  'zone.thicket.desc': '茂密的雜木林，枝葉遮天，視線不過數步之遙。',
  'zone.thicket.lore': '在林中遇襲，往往連防備都來不及——這裡是冷血獵人的狩場。',
  'zone.shrine.name': '神社',
  'zone.shrine.desc': '南部的神社，鳥居斑駁，石階爬滿青苔。',
  'zone.shrine.lore': '不知名的神，被遺忘地祭祀著。',
  'zone.farm_assoc.name': '農協大樓',
  'zone.farm_assoc.desc': '農業協會的倉庫大樓，堆著生鏽的農具與成袋化肥。',
  'zone.farm_assoc.lore': '鐮刀與鋤頭，在這座島上都成了凶器。',
  'zone.fish_assoc.name': '漁協大樓',
  'zone.fish_assoc.desc': '漁業協會的建築，瀰漫海腥味，牆上掛著破舊漁網。',
  'zone.fish_assoc.lore': '從窗口能望見港口——以及那艘等著優勝者的船。',
  'zone.south_peak.name': '南山頂',
  'zone.south_peak.desc': '南部的山頭，怪石嶙峋，視野不如北山開闊。',
  'zone.south_peak.lore': '易守難攻，適合負隅頑抗。',
  'zone.south_temple.name': '南寺',
  'zone.south_temple.desc': '南部的寺院，殿宇荒廢，蛛網密布。',
  'zone.south_temple.lore': '白日尚可，入夜後這裡格外瘆人。',
  'zone.reservoir.name': '貯水池（水壩）',
  'zone.reservoir.desc': '供應全島的貯水池與小型水壩，水聲在寂靜中格外清晰。',
  'zone.reservoir.lore': '開闊的水畔無處藏身，卻是必經的水源。',
  'zone.port.name': '港口',
  'zone.port.desc': '島南的港口，數艘船停泊著，纜繩在風中搖晃。',
  'zone.port.lore': '這是士兵與優勝者離島的唯一出口。',
  'zone.beach.name': '沙灘',
  'zone.beach.desc': '南岸的沙灘，海浪一波波拍上岸，遠處是巡邏的監視船。',
  'zone.beach.lore': '向大海望去，只有四處巡弋的船，提醒你無處可逃。',
  'zone.houses_south.name': '民家聚落（南）',
  'zone.houses_south.desc': '南側的住宅街，商店比別處多，貨架卻早被搬空。',
  'zone.houses_south.lore': '想找補給就得快——別人也是這麼想的。',

  // ── Story engine UI ──────────────────────────────────────────────
  'story.tap': '▶ 輕觸繼續',
  'story.kbd': '［空白/Enter］繼續　［1–3］選擇　［Esc］返回',
  'story.enterMatch': '⚔ 進入戰場',
  'story.complete': '本章完結',
  'story.allComplete': '～ 全篇完結 ～',
  'story.toMenu': '回主選單',
  'story.broken': '這個章節暫時無法進行，請返回主選單再試一次。',

  // ── Story cast（原創角色）──────────────────────────────────
  's.char.you': '你',
  's.char.sakura': '立花 さくら',
  's.char.rin': '黒沢 凜',
  's.char.kaede': '一ノ瀬 楓',
  's.char.hikari': '望月 ひかり',
  's.char.officer': '監督教官',
  's.char.voice': '廣播',

  // ── Chapter titles / summaries ──────────────────────────────────
  's.prologue.title': '序章：開始',
  's.prologue.sum': '一場校外教學，在一陣瓦斯後變了調。你在陌生的島上醒來，脖子上多了一個冰冷的項圈。',
  's.ch1.title': '第一章：初夜',
  's.ch1.sum': '夜幕降臨孤島。第一聲廣播響起，禁區開始擴張。你必須在恐懼與信任之間，做出第一個選擇。',
  's.ch2.title': '第二章：信任與背叛',
  's.ch2.sum': '結盟能讓你活得更久，也可能讓你死得更慘。當補給見底，誰還會站在你這邊？',
  's.ch3.title': '第三章：觀光協會的訊號',
  's.ch3.sum': '楓在廢棄的觀光協會大樓裡，找到了或許能癱瘓主辦方系統的方法——但時間正在流逝。',
  's.ch4.title': '第四章：獵殺者',
  's.ch4.sum': '凜不再躲藏。她以冷靜而精準的方式，一個接一個地清除名單上的人。下一個，會是你嗎？',
  's.ch5.title': '第五章：項圈的祕密',
  's.ch5.sum': '逃離這座島的唯一辦法，藏在每個人脖子上的項圈裡。代價，是有人必須冒死一試。',
  's.ch6.title': '終章：黎明',
  's.ch6.sum': '當天色將明，島上只剩下寥寥數人。你選擇成為倖存者、逃脫者，還是掀桌反抗的人？',

  // ── Prologue scenes ──────────────────────────────────
  's.prologue.s1.1': '校外教學的巴士在山路上行駛，窗外的綠意一閃而過。你昏昏欲睡。',
  's.prologue.s1.2': '一股甜膩的氣味悄悄滲進車廂。同學一個接一個垂下了頭。',
  's.prologue.s1.mid': '你伸手想推醒鄰座的同學，指尖卻越來越沉。最後映入眼底的，是司機座位後方那面——不知何時，已被人從外側上了鎖的隔板。',
  's.prologue.s1.3': '你想喊出聲，喉嚨卻發不出聲音。眼前一黑——',
  's.prologue.s2.1': '冰冷的地面。刺眼的日光燈。你在一間陌生的教室裡醒來。',
  's.prologue.s2.wake': '你下意識數著身邊倒臥的同學，數字越數越亂。指尖摸到頸間——一圈冰冷的金屬，不知何時已扣上。那一刻你才真正清醒：這不是惡夢，醒來，才是惡夢的開始。',
  's.prologue.s2.officer': '「都醒了？很好。歡迎來到本屆『計畫』的會場。」',
  's.prologue.s2.officer2': '他翻開手中的板夾，語氣像在念一份再普通不過的行程表：「報到、適應、淘汰——流程都印在你們座位底下的手冊裡。對了，逃生門已經焊死了。那是上一屆的人，教會我們的。」',
  's.prologue.s2.2': '你伸手摸向脖子——一圈金屬冰冷地箍著，無論如何都解不開。',
  's.prologue.s2.sakura': '「別……別亂動那個東西！教官說，硬拆會爆炸的……」',
  's.prologue.s2.after': '你緩緩把手放下。那女孩的聲音在發抖，卻仍硬撐著想安撫別人——你記住了她的眼神，也記住了自己掌心的冷汗。',
  's.prologue.s3.officer1': '「規則很簡單：你們要互相殘殺，直到只剩一人。那個人，就能活著離開。」',
  's.prologue.s3.officer2': '「島上會逐步劃出『禁區』。時間一到還待在禁區裡，項圈就會替你倒數。」',
  's.prologue.s3.officer3': '「每人發一份補給、一件武器——運氣好壞，自己認了。遊戲，現在開始。」',
  's.prologue.s3.after': '教室裡先是一片死寂，接著壓抑的啜泣、翻倒的椅子、有人衝向門口又被一道無形的界線逼了回來。監督教官只是抱著手，像在看一場早已預演過無數次的戲。倒數，已經開始。',
  's.prologue.s4.q': '坐在你旁邊的同學忽然站起來嘶吼。你——',
  's.prologue.s4.cA': '保持冷靜，先觀察情勢',
  's.prologue.s4.cB': '質問教官這一切的意義',
  's.prologue.s4.rA': '你壓下顫抖，冷靜地環顧四周。活下去，得先看清楚規則。',
  's.prologue.s4.rA.after': '你不動聲色地記下幾件事：監督教官腰間的遙控器、門邊穿黑衣的看守、牆上那台始終亮著紅燈的攝影機。情緒幫不了你，但這些細節，也許可以。',
  's.prologue.s4.rB': '「為什麼要這麼做？」你質問。',
  's.prologue.s4.rB.officer': '教官只是笑了笑：「問為什麼的人，通常活不久。」',
  's.prologue.s4.rB.after': '他的目光在你臉上多停了一秒，像替你的編號做了個記號。周圍的同學悄悄挪遠半步——在這座島上，出頭的釘子，往往最先被敲下去。你把不甘嚥回喉嚨，記住了：有些問題，只能用活著去回答。',
  's.prologue.s4.cC': '安撫身旁失控的同學',
  's.prologue.s4.rC': '你伸手按住那名同學顫抖的肩膀，壓低聲音說了句什麼。',
  's.prologue.s4.rC.after': '嘶吼漸漸化為粗重的喘息，整間教室緊繃的空氣，似乎也鬆了那麼一線。監督教官瞥了你一眼，沒有作聲。你忽然明白：在這裡，連一點點鎮定都是一種抵抗——而人們會記得，是誰先伸出了手。',
  's.prologue.s5.1': '人群被趕出校門，分散投放到島上各處。海風吹來，夜色正濃。',
  's.prologue.s5.sakura': '「等等！是你啊……太好了。我們……一起行動，好嗎？」立花さくら向你伸出手。',
  's.prologue.s5.q': '你——',
  's.prologue.s5.cA': '與さくら同行',
  's.prologue.s5.cB': '婉拒，獨自行動',
  's.prologue.s5.rA': '你握住了那隻顫抖的手。至少現在，你不是一個人。',
  's.prologue.s5.rA.sakura': '「……謝謝。」さくら破涕為笑，回握住你的手，「不管接下來會怎樣，我們都一起面對。」',
  's.prologue.s5.rA.end': '兩道身影並肩沒入夜色。遊戲才剛開始——但至少這一夜，有人與你共數彼此的呼吸。',
  's.prologue.s5.rB': '「抱歉……一個人比較安全。」你轉身沒入黑暗，背後傳來她輕輕的一聲嘆息。',
  's.prologue.s5.rB.mid': '你沒有回頭。在這座島上，心軟與遲疑，往往比刀刃更早要人的命——你這樣告訴自己，把那聲嘆息，連同心裡某種更柔軟的東西，一起留在了身後。',
  's.prologue.s5.rB.end': '黑暗很快吞沒了那聲嘆息。你獨自前行，腳步聲成了這座島上唯一肯回應你的東西。',
  's.prologue.s5.cC': '同行，但先說好規矩',
  's.prologue.s5.rC': '「可以一起走。」你頓了頓，「但先說好——誰想走，隨時都能走，不欠誰。」',
  's.prologue.s5.rC.sakura': '「……嗯，這樣很好。」さくら收回手，鄭重地點頭，「不勉強，也不背叛。這是我們的第一個約定。」',
  's.prologue.s5.rC.end': '沒有誓言，只有一條誰都能鬆開的繩。但正因為鬆得開，這一夜你們反而走得格外安穩。',

  // ── Chapter 1 scenes ──────────────────────────────────
  's.ch1.s1.scene': '入夜後，你被推進這座島的黑暗裡。手中只有一張粗糙的地圖、一支電筒，和一件被硬塞來的武器。校舍的輪廓在遠處黑成一塊剪影，同學們各自散入夜色——很快，你連他們的腳步聲都聽不見了。',
  's.ch1.s1.voice': '【廣播】各位同學晚安。以下地點即將成為禁區，請儘速離開……',
  's.ch1.s1.1': '冰冷機械的廣播在島上每個角落迴盪。求生的倒數，開始了。',
  's.ch1.s1.mid': '廣播的語氣客氣得近乎溫柔，反而更教人發寒。你告訴自己：一起上過課的人，不可能真的對彼此舉刀。然而黑暗裡漸近的腳步聲，正一步步把這份天真，從你身上剝下來。',
  's.ch1.s2.1': '黑暗中，一個身影踉蹌地朝你衝來，手裡握著什麼東西反著光——是望月ひかり，她哭著。',
  's.ch1.s2.hikari': '「對不起、對不起……我不想死！只要解決掉你，我就……！」',
  's.ch1.s2.q': '她揮刀撲上。你——',
  's.ch1.s2.cA': '奪下她的刀、制止她',
  's.ch1.s2.cB': '本能地反擊',
  's.ch1.s2.cC': '轉身就跑',
  's.ch1.s2.rA': '你扣住她的手腕，刀落在地。她癱坐下來，崩潰大哭。你救了一個人——也留下了一個變數。',
  's.ch1.s2.rA.hikari': '「為什麼……為什麼不還手？」ひかり抬起淚臉，聲音抖得不成樣，「我差點就殺了你。可你卻……謝謝你，把我從那個我自己手裡，拉了回來。」',
  's.ch1.s2.rA.after': '你扶她起身，掌心觸到她仍在發抖的手。你說不清這一刻救下的，是她，還是自己心裡某個還不肯認輸的部分。但你知道：只要還願意伸出手，你就還沒被這座島，真正變成它要的樣子。',
  's.ch1.s2.rB': '你的身體比腦袋更快。等回過神，她已經倒在血泊裡，眼裡還凝著恐懼。你殺了第一個人。',
  's.ch1.s2.rB.after': '手還在抖，掌心的溫度卻怎麼也散不掉。你想吐，想跪下道歉，想假裝這不是真的——可島不給你時間。你逼自己站直，把那聲「對不起」嚥回喉嚨：記住這份重量，但別讓它現在就壓垮你。活下去，才有資格懺悔。',
  's.ch1.s2.rC': '你拔腿狂奔，把哭喊聲拋在身後。逃避不可恥——但島會縮小，總有一天無處可逃。',
  's.ch1.s2.rC.after': '跑出很遠，那道哭聲卻像釘在耳膜上。你沒有殺她，也沒有救她——只是把選擇推給了下一個遇見她的人。你說不清這算不算更乾淨，只知道自己的手心，同樣全是冷汗。',
  's.ch1.s3.1': '你躲進一棟廢屋喘息。角落裡，一個冷靜的聲音響起。',
  's.ch1.s3.kaede': '「別緊張，我沒帶武器。我是一ノ瀬楓。我在想——這項圈，這系統，一定有破綻。」',
  's.ch1.s3.2': '她攤開一張島的草圖，指向東邊的觀光協會大樓。',
  's.ch1.s3.kaede2': '「那裡有電腦和線路。給我時間，也許我能讓所有項圈一起失效。你，願意賭一把嗎？」',
  's.ch1.s3.cA': '「賭。我信妳說的那個破綻。」',
  's.ch1.s3.cB': '「賭，但我會替自己留一條退路。」',
  's.ch1.s3.cC': '「我不賭系統，只賭自己活著走出去。」',
  's.ch1.s3.rA': '你沒有猶豫。楓怔了一下，隨即彎起眼睛。',
  's.ch1.s3.rA.kaede': '「……謝謝。被人毫不保留地信任，是會讓人想拼命的。給我三天——不，給我到下一次縮圈之前。」',
  's.ch1.s3.rB': '你答應了，但話說得很有分寸。楓不但不介意，反而點了點頭。',
  's.ch1.s3.rB.kaede': '「聰明。把命押在別人沒驗證過的計畫上，本來就是蠢事。留好退路——然後，盡量別用上它。」',
  's.ch1.s3.rC': '你把話說得很白。楓沉默了半晌，沒有反駁。',
  's.ch1.s3.rC.kaede': '「也對。我沒資格要你拿命陪我賭。那就各走各的——但若你改變主意，觀光協會大樓，我等你。」',
  's.ch1.s4.1': '窗外掠過一道沉著的身影。是黒沢凜，班上最冷靜的人——此刻，她手裡有槍。',
  's.ch1.s4.rin': '「楓的計畫？很美。但在它成功之前，我會先把名單清乾淨。包括你們。」',
  's.ch1.s4.2': '她沒有開槍，只是留下一句話，便消失在夜色裡。威脅，已經成形。',
  's.ch1.s4.after': '凜的腳步聲被夜色吞沒，那句話卻黏在你背上久久不散。你這才明白：在這座島上，最危險的從來不是吶喊著撲上來的人，而是早已算好你幾時該死、再從容扣下扳機的人。',
  's.ch1.s5.1': '夜還很長。禁區仍在擴張，而你，必須走進這座島，活下去。',
  's.ch1.s5.sakura': '「我不會照他們寫好的劇本死去。哪怕只剩我一個人記得大家的名字——我也要把它帶出這座島。」',
  's.ch1.s5.2': '立花さくら攥緊了掌心裡那枚冰冷的編號牌。恐懼還在，但它第一次有了形狀——一個她決定要打碎的形狀。',
  's.ch1.s5.end': '海風捲起遠處的廣播雜訊，像在催促。さくら朝你點了點頭——沒有退路的第一步，就從現在邁出。',

  // ── Chapter 2：信任與背叛 ──────────────────────────────
  's.ch2.s1.scene': '島嶼的時間以「廣播點名」切割——每隔幾小時，冰冷的女聲念出新增的死者編號，名單一截截變短。你學會在通報的空檔裡移動、在通報的瞬間屏息，把日子過成一種數字的退潮。',
  's.ch2.s1.voice': '【廣播】定時點名。新增除名編號——零四、一七、二二、三十。名單，又短了一截。願倖存者，活得比愧疚更久。',
  's.ch2.s1.1': '兩天過去，背包裡的乾糧見了底。你躲進一間民家，借著月光清點所剩無幾的補給。',
  's.ch2.s1.mid': '飢餓會放大每一個聲響，也放大每一分懷疑。你忽然明白：在這座島上最先見底的，從來不是乾糧，而是「能不能相信一個人」的餘裕。',
  's.ch2.s1.2': '門外傳來腳步聲。你屏住呼吸——是楓，她臉色凝重。',
  's.ch2.s2.kaede': '「有人在島上散播假情報，故意把同學引進禁區。再這樣下去，名單會空得比誰動手都快。」',
  's.ch2.s2.q': '楓要你幫忙拆穿那個造謠者。但她的消息，你又該全信嗎？',
  's.ch2.s2.cA': '相信楓，照她的計畫走',
  's.ch2.s2.cB': '留一手，自己查證',
  's.ch2.s2.rA': '你點頭。能在這座島上還願意拆穿謊言的人，本身就值得賭一把。',
  's.ch2.s2.rA.kaede': '楓怔了一下，似乎沒料到你答得這麼乾脆。她別過頭，聲音比平時低了些：「……謝了。在這裡，肯把背後交給別人的人不多了。我不會讓你後悔的——這一次，我說到做到。」',
  's.ch2.s2.rA.after': '你不確定楓的情報有幾分真，但你更清楚：若連願意拆穿謊言的人都不肯信，這座島就真的只剩謊言了。把背後交出去是一場賭注——而你選擇先賭一個，還願意說真話的人。',
  's.ch2.s2.rB.before': '你搖了搖頭，沒有立刻接下她的計畫。情報可以參考，但得由你自己的眼睛確認過，才算數。',
  's.ch2.s2.rB': '「我自己確認過再說。」楓沒有生氣，只是淡淡地說。',
  's.ch2.s2.rB.kaede': '「謹慎是對的——只要別謹慎到沒有人可信。」',
  's.ch2.s2.cC': '表面答應，暗中留一手',
  's.ch2.s2.rC': '你點了頭，笑得恰到好處——心裡卻把退路與疑點一一記下。結盟是真的，提防也是真的。',
  's.ch2.s2.rC.kaede': '楓看了你一眼，像是看穿了什麼，卻只是輕輕笑了：「這樣也好。在這座島上，太快全心信人的，往往活不久。」',
  's.ch2.s2.rC.after': '你笑著應和，心底卻有個角落悄悄涼了下去。在這座島上活下來的代價，或許就是再也無法毫無保留地，把背後交給任何人——包括，總有一天，連你都會開始懷疑自己。',
  's.ch2.s2.rB.after': '楓沒有多留，轉身沒入暗處前丟下一句：「查吧。等你確認完，我會在診所後門等你——如果那時你還願意來。」她的背影裡，沒有責怪，只有一種被反覆辜負後仍選擇等待的疲憊。',
  's.ch2.s3.1': '循線追查，你們在診所堵到了造謠者。沒想到，竟是看似最人畜無害的那個轉學生。',
  's.ch2.s3.2': '他笑著舉起手中的無線電：「我只是想活下去而已……難道你們不是嗎？」槍口，已經對準了你。',
  's.ch2.s3.kaede': '楓擋到你身前半步，聲音冷得像刀：「被假情報害死的人，不會因為你『只是想活下去』就回得來。把無線電放下——這是我最後一次好好說話。」',
  's.ch2.s3.cA': '放下武器，給他一條活路。',
  's.ch2.s3.cB': '不退，但只要他肯放下無線電。',
  's.ch2.s3.cC': '這種人留著，就是下一個被害者的伏筆。',
  's.ch2.s3.rA': '你緩緩垂下武器。那一瞬，他眼底閃過一絲動搖——可無線電「喀」地響了一聲，選擇權已不在你手上。',
  's.ch2.s3.rA.kaede': '楓輕聲說：「你比我善良。但願這座島，沒把這份善良變成你的弱點。」',
  's.ch2.s3.rB': '你沒有退，槍口卻沒有抬高半分。「放下它，你還能走。」你說。他的手指，仍在扳機上收緊。',
  's.ch2.s3.rB.kaede': '楓站在你身側，沒有勸阻，只低聲補了一句：「機會給過了。接下來，不是你的錯。」',
  's.ch2.s3.rC': '你做了最冷的判斷。話還沒說完，動作已經先出。',
  's.ch2.s3.rC.kaede': '楓沒有攔你。她只是看了你一眼，像把這一刻，悄悄記進了某份只有她看得見的名單。',
  's.ch2.s4.1': '謊言被拆穿，真正的廝殺也隨之而來。你握緊武器，迎向這座島的惡意。',
  's.ch2.s4.sakura': '「『我只是想活下去』——大家都這麼說。可是さくら不准這句話，變成傷害別人的藉口。」',
  's.ch2.s4.end': '對方的無線電還在沙沙作響，彷彿替這座島清點今夜的名單。さくら退到你身側，不再多言——剩下的話，只能交給接下來的每一步去回答。',

  // ── Chapter 3：觀光協會的訊號 ──────────────────────────
  's.ch3.s1.scene': '觀光協會大樓踞在島嶼東緣，落地窗外，港口的吊燈在夜裡明明滅滅，遠處燈塔的光每隔幾秒劃過海面。再往內陸，學校的訊號塔像一根冰冷的針，扎進這座島的心臟。',
  's.ch3.s1.kaede': '「就是這裡。」楓在觀光協會大樓的機房前蹲下，指尖在鍵盤上翻飛。「主辦方的訊號塔就在學校，我能從這裡反向干擾。」',
  's.ch3.s1.kaede2': '她沒有回頭，只低聲補了一句：「我不擅長打架。可是要讓那些躲在螢幕後面的人，嚐嚐被盯上的滋味——這個，我很擅長。」',
  's.ch3.s1.1': '螢幕上的進度條緩慢爬升。她需要時間——而時間，是這座島最奢侈的東西。',
  's.ch3.s1.voice': '【廣播】各位同學，午夜通報。存活人數——十一。較昨夜，少了七。請珍惜彼此剩下的相處時光。',
  's.ch3.s1.mid': '你盯著那條一格一格爬升的進度條，忽然覺得荒謬又心酸——在這座把人逼成野獸的島上，他們的希望，竟被縮小成一行還沒跑完的程式碼。而你願意，替這行程式碼擋下所有子彈。',
  's.ch3.s2.q': '遠處傳來腳步與槍聲，正在逼近。你要——',
  's.ch3.s2.cA': '守在門口，替楓擋下來人',
  's.ch3.s2.cB': '催楓加速，冒著燒壞機器的風險',
  's.ch3.s2.rA': '你堵在門口，像一道牆。「快點，我擋得住——大概吧。」',
  's.ch3.s2.rA.kaede': '楓頭也沒抬，手指在面板上翻飛，聲音卻軟了一瞬：「……別逞強。聽到不對勁就退，我不需要用你的命換來的那幾秒。」她頓了頓，「但——謝謝。這扇門，我就交給你了。」',
  's.ch3.s2.rB': '「跳過校驗、直接灌！」楓咬牙照做，機器發出刺耳的嗡鳴，火花四濺。',
  's.ch3.s2.rB.after': '指示燈一路飆紅，外殼燙得能煎蛋。「撐住……再三十秒就好——」話沒說完，一聲悶響，半邊面板黑了。楓咬牙切到備援：「還能跑，但只剩一次機會。別讓我白燒這台。」',
  's.ch3.s2.cC': '聲東擊西，把來人引去別處',
  's.ch3.s2.rC': '你抄起一截鋼管砸向走廊另一頭的鐵櫃，巨響在空樓裡炸開。腳步聲一窩蜂追著回音而去——你替楓，硬生生偷來了幾分鐘。',
  's.ch3.s2.rC.kaede': '「……你這人，腦袋轉得比我還快。」楓忍不住笑了一下，指尖卻沒停，「行，剩下的交給我——別走遠，回聲騙得了一時。」',
  's.ch3.s3.kaede': '「再給我三分鐘……不，兩分鐘！」楓的額頭滲出汗。',
  's.ch3.s3.bar': '進度條，停在了百分之九十。',
  's.ch3.s3.sakura': '「楓，看著我，別看進度條。」さくら的聲音壓得很穩，「你只管把訊號送出去，剩下的歸我。我們是一起進來的，就要一起出去。」',
  's.ch3.s3.kaede2': '「……嗯。」楓深吸一口氣，指尖不再發抖，「謝謝你，さくら。有你在，我好像就真的能做到。」',
  's.ch3.s3.beat': '那一瞬，倉庫裡彷彿只剩兩道呼吸，與一行緩緩爬升的數字。你忽然很想守住這一刻——守住這座島上，難得還沒被恐懼吃掉的東西。',
  's.ch3.s3.1': '就在此時，門被踹開。訊號還沒送出，敵人已經到了。',
  's.ch3.s4.kaede': '「百分之九十不是零。幫我擋住他們——把最後兩分鐘，交到我手上。」楓的指尖沒有一刻停下。',
  's.ch3.s4.cA': '死守門口，一個都別想進來。',
  's.ch3.s4.cB': '主動迎上去，把他們引離楓。',
  's.ch3.s4.cC': '把備用武器塞給さくら，並肩擋。',
  's.ch3.s4.rA': '你橫身堵在唯一的入口，把整條走廊變成只能一個一個過的窄門。',
  's.ch3.s4.rA.kaede': '「好位置。」楓頭也沒抬，「他們一次只能來一個——這兩分鐘，我守得住數字，你守得住門。」',
  's.ch3.s4.rB': '你沒有等他們進來，反而欺身衝出，把廝殺引向遠離倉庫的那一側。',
  's.ch3.s4.rB.kaede': '「喂——！」楓一驚，隨即明白了你的用意，咬牙把視線逼回螢幕，「……活著回來。聽見沒有。」',
  's.ch3.s4.rC': '你反手把備用武器拋給さくら。她穩穩接住，與你背靠背站定。',
  's.ch3.s4.rC.sakura': '「一起進來的，就一起擋。」さくら與你背貼著背，「楓只管數她的數字——這道門，有我們兩個。」',
  's.ch3.s4.1': '計畫成敗，全看接下來這一戰。你深吸一口氣，迎了上去。',
  's.ch3.s4.end': '螢幕的進度條一格一格往上爬，像在跟死亡賽跑。你把楓和那兩分鐘護在身後——這座島想要的答案，你打算用拳頭寫給它。',

  // ── Chapter 4：獵殺者 ──────────────────────────────────
  's.ch4.s1.scene': '夜更深了。濃霧自低窪處漫起，吞掉樹幹、吞掉聲音，連自己的呼吸都顯得突兀。林子裡每一步落葉都像踩在別人的神經上——你開始懂得，真正的獵人不會出聲，他們只是等。',
  's.ch4.s1.voice': '【廣播】禁區擴張通知。北部林線即將封鎖，霧中行動者請特別留意——能見度，從來不會站在獵物這一邊。',
  's.ch4.s1.1': '雜木林的霧氣裡，一個身影靜靜地站著，彷彿已經等了你很久。是凜。',
  's.ch4.s1.rin': '「楓的訊號，差一點就成了。可惜，差一點就是差很多。」她抬起槍，「在系統被關掉之前，我會先把你們關掉。」',
  's.ch4.s1.mid': '她的槍口很穩，穩得不像在洩憤，而像在執行一個早已算清代價的決定。你忽然懂了——凜不是享受獵殺，她只是搶先替所有人，把「下手」的罪一個人扛了。',
  's.ch4.s2.q': '她的指尖搭上扳機。你——',
  's.ch4.s2.cA': '正面迎戰，賭一個你死我活',
  's.ch4.s2.cB': '試著說服她加入',
  's.ch4.s2.cC': '利用霧氣脫離',
  's.ch4.s2.rA': '「那就來吧。」你舉起武器。既然退無可退，就只剩向前。',
  's.ch4.s2.rA.rin': '「好。」凜的唇角揚起極淺的弧——那不是笑，是獵人遇上值得出手的對手時的專注，「至少你不打算跪著死。這份膽子撐不過三招，但我會記得你曾經有過。」',
  's.ch4.s2.rA.after': '你聽出那句話底下的東西——她不是看輕你，是早替自己預習過無數次「對手的死法」。握緊武器的瞬間，你忽然不再怕輸：能逼黒沢凜認真出手，至少證明你還沒被這座島磨成一個數字。三招？那就讓她數到第四招。',
  's.ch4.s2.rB': '「你比誰都清楚這場遊戲有多荒謬——何不一起掀了它？」凜沉默了半秒，那半秒，或許就是裂縫。',
  's.ch4.s2.rB.rin': '「……一起？」她別開視線，槍口卻悄悄垂下幾分，「如果我信了你，到頭來卻沒成——那些因為我猶豫而多死的人，誰來算？我寧可當壞人，也不要再賭別人的命。」',
  's.ch4.s2.rB.after': '你忽然讀懂那半秒的猶豫：凜不是不信你，是不敢再信自己。她把每一條死亡都扛成自己的帳，於是搶先把自己變成怪物——這樣輸的那一天，就只需要恨一個人。',
  's.ch4.s2.rC': '你借著濃霧翻身退入林間。她沒有追——獵人，從不浪費子彈。',
  's.ch4.s2.rC.rin': '霧裡，凜對著你消失的方向低聲開口，輕得幾乎只說給自己聽：「跑吧。多活一晚，是一晚。等你想通了，再回來找我算帳。」',
  's.ch4.s2.rC.after': '那句低語，你其實聽見了。你沒有回頭——但你記住了：凜放你走，不是慈悲，而是一場賭注。她在等你帶回一個連她自己都還不敢相信的答案。霧在身後合攏，你加快腳步，把那份沉重一起帶進了夜裡。',
  's.ch4.s3.rin': '「別誤會，我不是在救你。我只是還沒決定，要把最後一發留給誰。」她退進陰影，槍口始終沒有放下。',
  's.ch4.s3.cA': '朝她喊：「妳不必一個人扛。」',
  's.ch4.s3.cB': '沉默，把她留下的破綻記在心底。',
  's.ch4.s3.cC': '不放下武器，戒備她的猶豫。',
  's.ch4.s3.rA': '你朝那道正退入霧中的背影喊了一句。話一出口，霧裡的腳步聲，停了半拍。',
  's.ch4.s3.rA.rin': '「……多管閒事。」凜的聲音從霧裡飄回來，比方才軟了一線，「但——謝謝你，沒朝我的背影開槍。」',
  's.ch4.s3.rB': '你沒有出聲，只把她話裡那道裂縫，悄悄收進心底，留待還用得上的那一天。',
  's.ch4.s3.rB.rin': '「不說話？也好。」霧裡的聲音聽不出情緒，「會閉嘴的人，往往比會開槍的人，活得久一點。」',
  's.ch4.s3.rC': '你沒有放下武器，目光追著霧裡每一絲晃動——她的猶豫是真的，但這座島，從不為猶豫的人留活路。',
  's.ch4.s3.rC.rin': '「聰明。」霧裡傳來一聲極輕的氣音，分不清是讚許還是嘲弄，「別把這份警覺，在走到我面前之前就用完了。」',
  's.ch4.s3.1': '無論你的選擇是什麼，凜都不會是最後一個擋在你面前的人。求生，仍在繼續。',
  's.ch4.s3.2': '你終於聽懂她話裡的裂縫——連最冷的人，也在替自己尋找一個不必扣下扳機的理由。',
  's.ch4.s3.end': '凜的身影融進陰影，留你獨自面對下一個轉角。遠處槍聲此起彼落——這座島不會等任何人想通，下一場廝殺，已經在等你了。',

  // ── Chapter 5：項圈的祕密 ──────────────────────────────
  's.ch5.s1.scene': '破曉前最深的暗裡，你們縮在港口倉庫的角落。潮水拍打防波堤，一下一下，像在替所剩無幾的人數計時。遠處燈塔仍盡責地轉著，那道光卻照不進任何人的眼睛。',
  's.ch5.s1.voice': '【廣播】特別通知。存活人數逼近個位數。主辦方謹此提醒：當倖存者剩餘三人，解除碼將下發至各位項圈。優勝近在咫尺——只要你願意，親手送走身邊最後幾個人。',
  's.ch5.s1.kaede': '「我看懂了。」楓的聲音發顫，「項圈的解除碼，會在『最後三人』時送進每個人的項圈——這是給優勝者的鑰匙。但只要有人願意當誘餌……我們能把它整串導出來。」',
  's.ch5.s1.1': '導出，意味著有人得故意走進射程，把自己當成訊號的中繼。成功，所有人得救；失敗，那人當場引爆。',
  's.ch5.s1.mid': '一條命，換所有人的明天——這道算式聽起來太划算，划算到讓人作嘔。你終於看清項圈真正的惡意：它不只鎖住脖子，更逼著每個人，學會把「誰該去死」算成一筆帳。',
  's.ch5.s1.hikari': '「那……時間，讓我來數吧。」一直沒出聲的ひかり輕輕舉起手，聲音細卻穩，「我跑不快，也不會打架。可是只要有人盯著秒數、有人記得你們幾點該回來——你們就不會只是一串會歸零的數字。這個，我做得到。」',
  's.ch5.s1.after': '你看著那雙不會打架的手，認真地比出一個「開始計時」的手勢。在這座把人逼成數字的島上，她偏偏選擇去守護「時間」本身——好讓每個歸來的人，都還記得自己是誰。你忽然覺得，這場仗，也許真的值得打。',
  's.ch5.s2.q': '楓看著你。這一次，沒有人能替你決定。你——',
  's.ch5.s2.cA': '自願當誘餌',
  's.ch5.s2.cB': '另尋不必犧牲的辦法',
  's.ch5.s2.rA': '「我去。」你聽見自己這麼說。さくら想攔，卻被你輕輕推開——有些路，只能一個人走。',
  's.ch5.s2.rA.sakura': '「你最好給我活著回來。」さくら的眼眶紅了，卻硬是把淚逼回去，「我不准任何人替我『犧牲』——你只是先過去，然後等我們追上。聽懂沒有？」',
  's.ch5.s2.rA.after': '你笑著點頭，把那句「如果回不來」嚥了回去。中繼點的座標在掌心發燙，你忽然懂了凜當初的心情——把最危險的位置留給自己，不是勇敢，只是再也受不了，眼睜睜看著別人替你去死。',
  's.ch5.s2.rB': '「一定還有別的辦法。」你不肯認命。楓苦笑。',
  's.ch5.s2.rB.kaede': '「但願這座島，給得起我們時間。」',
  's.ch5.s2.rB.sakura': '「時間不夠，我們就自己擠出來。」さくら攥緊了拳，聲音不大，卻像釘子一樣牢，「我不要任何人被當成代價——這一次，連『犧牲』兩個字，都不准它出現。」',
  's.ch5.s2.rB.after': '沒有人出聲附和，卻也沒有人別開眼。楓低下頭，把計畫又算了一遍——這一次，她把「來不及」三個字，從紙上劃掉了。你明白那不是把握，只是一群人決定不再向時間低頭，哪怕時間，從來就不站在你們這邊。',
  's.ch5.s2.cC': '提議輪流分攤，沒有人獨自送死',
  's.ch5.s2.rC': '「要冒險，就一起冒。」你說，「中繼輪著當，誰撐不住就換人——把『一個人去死』改成『所有人一起活下來』。」',
  's.ch5.s2.rC.kaede': '楓怔了一下，隨即用力點頭，眼裡有光：「……對。我怎麼沒想到。把風險拆開，數學就不一樣了。我重算路徑——這次，算進每一個人。」',
  's.ch5.s2.rC.after': '沒有人需要當英雄，也沒有人被准許獨自赴死。這念頭簡單得近乎天真，簡單到這座島從沒打算讓你們想到——它要的是一個倖存者，你們偏要塞給它一整群活人。',
  's.ch5.s3.1': '計畫進入最後階段。當第一縷天光刺破海平面，這座島的遊戲，也將迎來終局。',
  's.ch5.s3.kaede': '楓鎖死最後一段程式碼，別過臉不敢看你：「中繼的座標……是我算的。要是出了差錯，是我害的。」她深吸一口氣，逼自己抬眼，「所以你一定要回來——給我一個說對不起、也說謝謝的機會。」',
  's.ch5.s3.hikari': '「我會數著時間，等你回來。」ひかり的聲音很輕，卻把每個字都壓得很穩，「所以——一定要回來喔。」',
  's.ch5.s3.cA': '對楓說：座標我信，回不來也不是妳的錯。',
  's.ch5.s3.cB': '對ひかり笑：數到我回來為止，一秒都別少。',
  's.ch5.s3.cC': '什麼都不說，只把武器再檢查一遍。',
  's.ch5.s3.rA': '你按住楓那隻還在發抖的手，把每個字都說得很慢。',
  's.ch5.s3.rA.kaede': '楓的眼眶一下子紅了，卻倔強地不讓淚落下：「……回來再說這些。我把『對不起』和『謝謝』，都記在你回來的那一刻。」',
  's.ch5.s3.rB': '你朝ひかり比了個「拜託了」的手勢，扯出一個盡量輕鬆的笑。',
  's.ch5.s3.rB.hikari': '「嗯！」ひかり用力點頭，把碼錶按在胸口，「我會數得很大聲——大聲到你在再遠的地方，都聽得見回家的拍子。」',
  's.ch5.s3.rC': '你沒有多話，只是把武器的每一處再確認一遍——彈匣、扣帶、握感。沉默，有時比承諾更接近認真。',
  's.ch5.s3.rC.hikari': 'ひかり看著你的背影，沒有催，只把計時的拇指輕輕搭上按鈕：「……我懂。話留著，回來再說。」',
  's.ch5.s3.end': 'ひかり的話像一枚壓在掌心的暖石。你最後看了眼那道將亮未亮的天光，轉身走進尚未散去的夜——這一回，你不只是為了活著，而是為了回得來。',

  // ── Chapter 6：終章 黎明 ───────────────────────────────
  's.ch6.s1.scene': '第一道灰白的光從海平線滲開，整座島浸在一種不真實的安靜裡——彷彿連這場遊戲，也屏住了呼吸。草葉上凝著夜露，頸間的項圈依舊冰冷，提醒你昨夜並非一場夢。',
  's.ch6.s1.1': '島上只剩寥寥數人。槍聲稀了，海浪聲反而清晰起來。天，要亮了。',
  's.ch6.s1.voice': '【廣播】各位同學，最後通報。存活——三。恭喜你們走到這裡。距離『優勝者』，只剩兩個名字的距離。',
  's.ch6.s1.2': '你站在燈塔下，手裡握著用無數人的命換來的選擇。最後一步，由你決定。',
  's.ch6.s1.mid': '海風裡，那些再也走不到黎明的臉一張張浮現——有人替你擋過刀，有人到最後仍喊著你的名字。你忽然明白：接下來這一步，從來不只是為了自己活著，而是為了讓他們的「活過」，不被這座島輕易抹去。',
  's.ch6.s1b.1': '你在心裡，一個一個喊了他們的名字。沒有名單，沒有編號——只有你記得的、笑過哭過的同學。',
  's.ch6.s1b.sakura': '「不管你選哪條路，」さくら不知何時站到你身旁，聲音很輕卻很穩，「我都陪你走完。我們答應過彼此的——誰都不准，一個人扛。」',
  's.ch6.s1b.kaede': '「能拆的後門，我都留給你了。」楓不知何時也到了，肩上還掛著那台改了又改的訊號機，「剩下的——換你來寫結局。我們負責，盯著你把它寫完。」',
  's.ch6.s1b.hikari': '「時間……我一直數著呢。」ひかり輕聲開口，指尖在掌心一下、一下地點著，像替誰守著節拍，「你回來的時刻，我會記得。所以——一定要回來，讓我數到你。」',
  's.ch6.s1b.absent': '海風捎來鹹澀的氣味。她們之中，有人沒能一起走到這裡——那份重量沒有人說出口，卻誰都記得。',
  's.ch6.s1b.2': '燈塔的光掃過海面，像在替這座島，數最後一次倒數。是時候了。',
  's.ch6.s2.q': '三條路在眼前展開——每一條，都要拿某樣東西去換。你深吸一口氣，做出最後的選擇——',
  's.ch6.s2.cA': '成為最後的倖存者',
  's.ch6.s2.cB': '帶著鑰匙，逃離孤島',
  's.ch6.s2.cC': '掀翻這張桌子，反抗到底',
  's.ch6.e1.1': '你撐到了最後。當直升機的轟鳴蓋過海浪，你成了名單上唯一的名字。',
  's.ch6.e1.2': '他們替你戴上「優勝者」的頭銜。可你知道，活下來的人，從此再也睡不安穩。',
  's.ch6.e2.1': '解除碼生效，項圈一個接一個鬆脫、落地。你帶著還活著的人，奔向港口那艘船。',
  's.ch6.e2.2': '引擎發動，孤島在身後縮成一個黑點。自由的滋味，鹹得像淚。',
  's.ch6.e3.1': '你沒有逃，也沒有獨活。你舉起楓改造過的訊號，對準了監督教官的本部。',
  's.ch6.e3.officer': '本部的喇叭裡，監督教官的聲音第一次起了波瀾：「你以為按下那個鍵，就能改變什麼？這遊戲我們辦過幾十屆，每一屆都有人這麼想——」話沒說完，便被你的訊號蓋了過去。',
  's.ch6.e3.2': '「這場遊戲，該結束了。」螢幕全暗的那一刻，你不知道前方是什麼——但至少，不再是他們寫好的劇本。',
  's.ch6.e1.3': '「對不起……也謝謝你們，把活下去的份，一起交給了我。」她對著空無一人的海，輕聲說。',
  's.ch6.e1.end': '直升機升空，島嶼在腳下縮成一塊褪色的疤。你贏了這場遊戲——可從今往後，每一個安穩的夜裡，都會有人在你夢中輕輕喊你的名字。',
  's.ch6.e2.3': '「我設計的訊號，本來只是想讓誰活著看到明天。能看到的人是你們——這樣就夠了。」',
  's.ch6.e2.end': '甲板上沒有人歡呼。倖存的人擠在船舷，望著那座吞掉許多名字的島，一點點沉進晨霧裡。你知道有些人永遠留在了那裡——而你們能做的，是替他們把今後的每一個明天，都好好活著。',
  's.ch6.e3.3': '「就算這只是另一個更大的牢籠，我也要親手敲開第一道門。」她沒有回頭。',
  's.ch6.e3.end': '本部的螢幕一塊塊熄滅，倒數歸零，廣播第一次安靜了下來。沒有直升機，沒有船，前方只有未知——但這一次，翻開下一頁的手，是你們自己的。劇本被撕了，故事才正要由活下來的人，重新寫起。',
  's.ch6.complete': '—— 你的故事，在此暫告一段落。',
} as const

export type JKGameMsgKey = keyof typeof zhTW
